<template>
    <div class=" h-[100vh] relative">
        <div class="w-full h-full absolute"><img src="../../assets/Backgroundpapsi.jpg" class="object-cover w-full h-[100vh] opacity-80">
        </div>
            <div class="fixed flex justify-center w-full h-full items-center">
                <div class="bg-[#EBEBEB] h-[550px] w-[1000px] rounded-xl flex shadow-md border-[#026b00e7] border shadow-[#353434]	mx-4">
                    <div class="w-[50%] relative overflow-hidden shadow-xl rounded-l-xl bg-[#e6e4e4] max-sm:w-full max-sm:rounded-xl">
                        <div class="flex flex-col mt-[70px] items-center px-[80px] h-full w-full max-sm:px-12">
                            <div class="flex flex-col justify-center items-center gap-2">
                                <img src="../../assets/HrisLogo.png">
                                <!-- <p class="font-bold text-2xl text-[#016B00]">LOGIN</p>
                                <p class="font-semibold text-xs text-[#016B00]">HUMAN RESOURCES INFORMATION HUB</p> -->
                            </div>
                            <div class="flex flex-col w-full gap-7 z-10 mt-[40px]">
                                <input type="text" class="w-full px-5 py-3 rounded-xl outline-none text-[#016B00]  border-b-[#016B00] border-b-[2px]  bg-[#d8d8d867] text-sm shadow-sm  shadow-[#353434]" placeholder="Username" @input="user = user.toUpperCase()" v-model="user">
                                <div class="relative">
                                    <input  class="w-full px-5 py-3 rounded-xl outline-none text-[#016B00]   border-b-[#016B00] border-b-[2px]   bg-[#d8d8d867] text-sm  shadow-sm  shadow-[#353434]" :type="ShowPassword" placeholder="Password" v-model="pass " @keyup.enter="$emit('loginview',{ user },{ pass })">
                                    <button class="absolute right-5 top-2.5 outline-none select-none" @click="Showpass">
                                        <div class="flex items-center">
                                            <div v-if="ShowPassword == 'password'">
                                                <Closepassword/>
                                            </div>
                                            <div v-else>
                                                <Showpassword/>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div class="flex flex-col  h-full w-full z-10 ">
                                <div class="flex justify-center items-center h-[30px]">
                                    <p class="text-[#a03131]  text-center text-xs font-semibold">{{ error }}</p>
                                </div>
                                <div class="mt-1">
                                    <button class="py-3 px-2 rounded-lg bg-[#CCAF12] w-full text-xs font-semibold text-[#016B00] shadow-sm  shadow-[#353434] hover" @click="$emit('loginview',{ user },{ pass })">LOGIN</button>
                                    <p class="text-[#6b6b6b] text-xs px-2 mt-2"><button @click="$emit('forgot')" class="hover:text-[#016B00] mt-2">Forgot Password?</button></p>
                                </div>
                            </div>
                            
                        </div>
                        <!-- <div>
                            <img src="../../assets/papsi.png" class="w-[180px]  absolute bottom-0 right-0">
                        </div>
                        <div>
                            <img src="../../assets/papsi-grass.png" class="absolute bottom-0 w-full rounded-l-xl h-[300px]">
                        </div> -->
                    </div>
                    <div class="relative w-[50%] bg-[#016B00] shadow-2xl rounded-r-xl rounded-t-lg max-sm:hidden">
                        <div class=" w-full h-full absolute rounded-lg">
                            <img src="../../assets/papsi-bgimage.png" class="  rounded-r-xl  h-full  rounded-lg w-full " >
                        </div>
                        <div class="flex flex-col w-full h-full justify-center items-center  gap-6
                        mt-6 z-50 relative">
                            <div class="text-center z-50">
                                <p class="text-2xl font-bold text-white">WELCOME KA-MAY-ARI</p>
                                <p class="text-xs font-italic text-white">Serving the AFP since 1981</p>
                            </div>
                            <div class="z-50">
                                <img src="../../assets/papsi.png" class="w-[250px]  z-50   ">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Showpassword from "../icons/ShowPassword.vue"
import Closepassword from "../icons/ClosePassword.vue"



export default defineComponent({
    components:{
        Showpassword,
        Closepassword

    },

    data(){
        return{
            user: '',
            pass: '',
            ShowPassword:'password'
        }
    },
    props:{
        error:{
            type: String
        }
    },
    methods:{
        ClearText(){
            this.pass = ''
        },
        Showpass(){
            if(this.ShowPassword == 'password'){
                this.ShowPassword = 'text'
            }
            else{
                this.ShowPassword = 'password'
            }
        }
    }
})

</script>